import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChatMessageComponent } from '@core/src/nedoShared/features/chat/components/ChatComponent/ui/ChatMessage/ChatMessage';
import { getRequiredLabItemNames } from '@core/src/nedoShared/features/consultations/helpers/requiredAttachments';
export const ProviderResultsServiceMessage = ({ consultation, role, message, onCheckResults, }) => {
    const { t } = useTranslation();
    const hasLabResults = (message.attachments || []).some((a) => a.type === 'lab_results');
    if (!hasLabResults)
        return null;
    const content = t('label.test_results_added', {
        testResults: getRequiredLabItemNames(consultation),
    });
    const handleActionClick = () => {
        const attachments = (message.attachments || []).filter((a) => a.type === 'lab_results');
        onCheckResults(attachments);
    };
    const messageToSend = {
        _id: `${message._id}-provider-upload-msg`,
        version: 0,
        created: new Date().toISOString(),
        modified: null,
        chat_id: message.chat_id,
        thread_id: '',
        role_id: 0,
        content,
        attachments: [],
    };
    const actions = [{ type: 'check-results', data: { url: '' } }];
    return (_jsx("div", Object.assign({ className: "mt-5" }, { children: _jsx(ChatMessageComponent, { message: messageToSend, role: role, showTimestamp: role !== 'client', actions: actions, onActionClick: handleActionClick, onAttachmentClick: () => { } }) })));
};
export default ProviderResultsServiceMessage;
